import $ from 'jquery';
import { disableElement, getInputValue } from '../utils/input';
import { matchesCriteria } from '../utils/criteria';
import { CodeMirrorEditor } from './code-mirror-editor';
const ELEMENT_SELECTOR = '.js__disable-on-target-value';
export class DisableOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => {
            let $element = $(element);
            if ($element.hasClass('ui dropdown') && $element.find('select').length) {
                $element = $element.find('select');
            }
            const targetSelectors = $element.data('target').split(',');
            targetSelectors.forEach((targetSelector) => {
                let $target = this.getTarget(targetSelector, $element);
                $target.each((index, element) => {
                    $(element).on('change', event => {
                        const $innerElements = $element.find(ELEMENT_SELECTOR);
                        this.handleValueChange($(event.currentTarget), $element);
                        $innerElements.each((index, innerElement) => {
                            let $innerElement = $(innerElement);
                            if ($innerElement.hasClass('ui dropdown') && $innerElement.find('select').length) {
                                $innerElement = $innerElement.find('select');
                            }
                            const innerTargetSelectors = $innerElement.data('target').split(',');
                            innerTargetSelectors.forEach((innerTargetSelector) => {
                                let $innerTarget = this.getTarget(innerTargetSelector, $element);
                                this.handleValueChange($innerTarget, $innerElement);
                            });
                        });
                    });
                });
                $target.each((index, target) => {
                    this.handleValueChange($(target), $element, 0);
                });
            });
        });
    }
    static getTarget(selector, $element) {
        let $target = $(selector);
        if ($element.data('target-and-field-closes-wrapper')) {
            $target = $($element.closest($element.data('target-and-field-closes-wrapper')).find($element.data('target')));
        }
        if ($target.hasClass('ui dropdown') && $target.find('input').not('.search').length) {
            $target = $target.find('input').not('.search');
        }
        return $target;
    }
    static handleValueChange($target, $element, duration = 300) {
        const { criteriaValue, disabledValue, clearDisabled, hideDisabled, inverseCriteria, disableDirectElement, target, triggerChangeOnEnable, everyTarget, withoutErrors, withErrors, checkByOptionValue, } = $element.data();
        let disable = false;
        let isWithoutErrors;
        let value = '';
        const targetSelectors = target.split(',');
        if (targetSelectors.length && everyTarget) {
            disable = targetSelectors.every((targetSelector) => {
                let $target = this.getTarget(targetSelector, $element);
                return matchesCriteria(criteriaValue, getInputValue($target), inverseCriteria);
            });
        }
        else if (targetSelectors.length && checkByOptionValue) {
            let value = getInputValue($target);
            let optionValue = $target.parent().find(`[data-value="${value}"]`).data('option-value');
            if (!optionValue) {
                optionValue = $target.parent().find(`[data-option-value]`).data('option-value');
            }
            isWithoutErrors = !$target.closest('.field').hasClass('error');
            disable = matchesCriteria(criteriaValue, optionValue, inverseCriteria);
        }
        else if (targetSelectors.length) {
            value = getInputValue($target);
            disable = targetSelectors.some((targetSelector) => {
                let $target = this.getTarget(targetSelector, $element);
                isWithoutErrors = !$target.closest('.field').hasClass('error');
                return matchesCriteria(criteriaValue, getInputValue($target), inverseCriteria);
            });
        }
        else {
            let value = getInputValue($target);
            isWithoutErrors = !$target.closest('.field').hasClass('error');
            disable = matchesCriteria(criteriaValue, value, inverseCriteria);
        }
        const disabledValueMatchedIndex = typeof criteriaValue === 'string' ? criteriaValue?.split(',').indexOf(String(value)) : null;
        disableElement($element, (disable && (withoutErrors ? isWithoutErrors : true)) || (withErrors ? !isWithoutErrors : false), disabledValueMatchedIndex ? disabledValue?.split(',')[disabledValueMatchedIndex] : disabledValue, clearDisabled, hideDisabled, disableDirectElement, triggerChangeOnEnable, duration);
        setTimeout(() => {
            const containCodeMirror = $element.hasClass('js__code-mirror-editor-source');
            const isCodeMirrorLoaded = $('.js__code-mirror-accordion-content.loaded.active').length;
            if (containCodeMirror && !isCodeMirrorLoaded && !disable) {
                const $activeAccordion = $('.js__code-mirror-accordion-content.active');
                CodeMirrorEditor.init($activeAccordion);
                $activeAccordion.addClass('loaded');
            }
        }, duration + 1000);
    }
}
